"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseExtMetaPropertyValue = exports.isViewableVideo = exports.isViewableRcpFile = exports.isViewableOfficeFile = exports.isViewableInProcessing = exports.isViewableImageNotProcessed = exports.isViewableImage = exports.isViewable = exports.isValidMatFile = exports.isSuspend = exports.isRvt = exports.isProcessing = exports.isProcessFailure = exports.isPdf = exports.isImageSupportLeafletView = exports.isIfc = exports.isFolder = exports.isFileSupportGUID = exports.isFdx = exports.isExtractionSuccess = exports.isEditableOfficeFile = exports.isDwg = exports.isC4rSingle = exports.isC4rShared = exports.isC4r = exports.isAggregateModel = exports.getVersionNumber = exports.getTipVersionUrn = exports.getOpenUrl = exports.getObjectIdByStorageUrn = exports.getFileExtension = exports.getExtMetaProperties = exports.getEntityUpdateInfo = exports.getDocType = exports.getBucketIdByStorageUrn = exports.decodeFileName = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _commons = require("./commons");
var _consts = require("./consts");
var _dates = require("./dates");
var _models = require("../models");
/**
 * Get the file extension from the file name.
 * @param filename - the file name
 * @returns the file extension
 */
var getFileExtension = exports.getFileExtension = function getFileExtension(filename) {
  if (!filename || filename.indexOf('.') === -1) {
    return '';
  }
  var extension = filename.split('.').pop() || '';
  return extension.toLowerCase();
};

/**
 * Check whether the file type supports to match sheets in different versions by sheet guid
 *
 * @param fileName - the file name
 * @returns whether the file support guid
 */
var isFileSupportGUID = exports.isFileSupportGUID = function isFileSupportGUID(fileName) {
  var extension = getFileExtension(fileName);
  if (extension) {
    return _consts.SUPPORT_GUID_TYPES.includes(extension);
  }
  return false;
};

/**
 * Decode the file name.
 *
 * @param name - the file name
 * @returns the decoded file name
 */
var decodeFileName = exports.decodeFileName = function decodeFileName(name) {
  try {
    return decodeURIComponent(name || '');
  } catch (error) {
    return name;
  }
};

/**
 * Get the version number from the version urn.
 *
 * @param version - the version urn
 * @returns the version number
 */
var getVersionNumber = exports.getVersionNumber = function getVersionNumber(version) {
  if (version) {
    return Number(version.substring(version.lastIndexOf('=') + 1));
  }
  return undefined;
};

/**
 * Get the tip version urn.
 *
 * @param entity - the entity object
 * @returns the tip version urn
 */
var getTipVersionUrn = exports.getTipVersionUrn = function getTipVersionUrn(entity) {
  var urn = entity.version.urn,
    latestVersion = entity.latestVersion;
  var versionNumber = Number(getVersionNumber(urn));
  if (versionNumber === latestVersion) return urn;
  return "".concat(urn.substring(0, urn.lastIndexOf('=') + 1)).concat(latestVersion);
};

/**
 * Get latest entity update info
 * @param doc - the entity object
 * @returns the latest entity update info
 */
var getEntityUpdateInfo = exports.getEntityUpdateInfo = function getEntityUpdateInfo(doc) {
  var lastModifiedTime = doc.lastModifiedTime,
    lastModifiedUserId = doc.lastModifiedUserId,
    lastModifiedUserName = doc.lastModifiedUserName;

  // Reuse the one inside lineage if no valid info
  if (!doc.version || !doc.version.lastModifiedTime) {
    return {
      lastModifiedTime: lastModifiedTime,
      lastModifiedUserName: lastModifiedUserName,
      lastModifiedUserId: lastModifiedUserId
    };
  }
  var _doc$version = doc.version,
    versionUpdateTime = _doc$version.lastModifiedTime,
    versionUpdateUser = _doc$version.lastModifiedUserName,
    versionUpdateUserId = _doc$version.lastModifiedUserId;
  var isLineageNear = lastModifiedTime ? lastModifiedTime.localeCompare(versionUpdateTime) > 0 : false;
  return {
    lastModifiedTime: isLineageNear ? lastModifiedTime : versionUpdateTime,
    lastModifiedUserName: isLineageNear ? lastModifiedUserName : versionUpdateUser,
    lastModifiedUserId: isLineageNear ? lastModifiedUserId : versionUpdateUserId
  };
};

/**
 * Get the entity field value from version or entity level.
 *
 * @param entity - the entity object
 * @param key - the field key
 * @returns the field value
 */
var getEntityField = function getEntityField(entity, key) {
  return (0, _commons.getValue)(entity, "version.".concat(key)) || (0, _commons.getValue)(entity, key);
};

/**
 * Check an item is folder or not.
 * If there is folderType property, it is folder
 *
 * @param entity - the entity object
 */
var isFolder = exports.isFolder = function isFolder(entity) {
  if (!entity) return false;
  if ('folderType' in entity && !!entity.folderType) return true;
  return false;
};

/**
 * Check an item is given type or not.
 *
 * @internal
 *
 * @param entity - the entity object
 * @param format - the target file format
 * @returns whether the file is the given type
 */
var isFileType = function isFileType(entity, format) {
  if (entity && entity.fileName) {
    return getFileExtension(entity.fileName) === format;
  }
  return false;
};

/**
 * Check a file is PDF or not.
 *
 * @param entity - the file entity with fileName property
 */
var isPdf = exports.isPdf = function isPdf(entity) {
  return isFileType(entity, 'pdf');
};

/**
 * Check a file is RVT or not.
 *
 * @param entity - the file entity with fileName property
 */
var isRvt = exports.isRvt = function isRvt(entity) {
  return isFileType(entity, 'rvt');
};

/**
 * Check a file is RVT and from Revit cloud model.
 *
 * @param entity - the file entity with fileName and documentType properties
 */
var isC4r = exports.isC4r = function isC4r(entity) {
  var _entity$version;
  return isRvt(entity) && ((_entity$version = entity.version) === null || _entity$version === void 0 ? void 0 : _entity$version.documentType) === 'c4r';
};

/**
 * Check a file is RVT and from Revit cloud model with single permission.
 *
 * @param entity - the file entity with fileName, documentType and sharedModel properties
 */
var isC4rSingle = exports.isC4rSingle = function isC4rSingle(entity) {
  var _entity$version2, _entity$version3;
  return isC4r(entity) && ((_entity$version2 = entity.version) === null || _entity$version2 === void 0 ? void 0 : _entity$version2.sharedModel) === 'singleUser' && !((_entity$version3 = entity.version) !== null && _entity$version3 !== void 0 && _entity$version3.copyFromVersion);
};

/**
 * Check a file is RVT and from Revit cloud model with shared permission.
 *
 * @param entity - the file entity with fileName, documentType and sharedModel properties
 */
var isC4rShared = exports.isC4rShared = function isC4rShared(entity) {
  var _entity$version4, _entity$version5;
  return isC4r(entity) && ((_entity$version4 = entity.version) === null || _entity$version4 === void 0 ? void 0 : _entity$version4.sharedModel) === 'multiUser' && !((_entity$version5 = entity.version) !== null && _entity$version5 !== void 0 && _entity$version5.copyFromVersion);
};

/**
 * Check a file is IFC or not.
 *
 * @param entity - the file entity with fileName property
 */
var isIfc = exports.isIfc = function isIfc(entity) {
  return isFileType(entity, 'ifc');
};

/**
 * Check a file is DWG or not.
 *
 * @param entity - the file entity with fileName property
 */
var isDwg = exports.isDwg = function isDwg(entity) {
  return isFileType(entity, 'dwg');
};

/**
 * Check a file is FDX or not.
 *
 * @param entity - the file entity with fileName property
 */
var isFdx = exports.isFdx = function isFdx(entity) {
  var _entity$version6;
  return (entity === null || entity === void 0 ? void 0 : (_entity$version6 = entity.version) === null || _entity$version6 === void 0 ? void 0 : _entity$version6.mimeType) === _consts.FILE_MIME_TYPE.FDX || (entity === null || entity === void 0 ? void 0 : entity.mimeType) === _consts.FILE_MIME_TYPE.FDX;
};

/**
 * Check a file is aggregate model or not.
 *
 * @param entity - the file entity with fileName property
 */
var isAggregateModel = exports.isAggregateModel = function isAggregateModel(entity) {
  var _entity$version7;
  return (entity === null || entity === void 0 ? void 0 : (_entity$version7 = entity.version) === null || _entity$version7 === void 0 ? void 0 : _entity$version7.mimeType) === _consts.FILE_MIME_TYPE.COMP || (entity === null || entity === void 0 ? void 0 : entity.mimeType) === _consts.FILE_MIME_TYPE.COMP;
};

//
// Process and extraction state related checks
//

var isProcessingState = function isProcessingState(state) {
  return [_consts.ENTITY_STATUS.PROCESSING, _consts.ENTITY_STATUS.EXTRACTION_PENDING, _consts.ENTITY_STATUS.EXTRACTION, _consts.ENTITY_STATUS.PROCESSING_PROMOTING, _consts.ENTITY_STATUS.PROCESSING_COPYING].includes(state);
};
var isProcessing = exports.isProcessing = function isProcessing(entity) {
  var moveState = entity ? getEntityField(entity, 'moveState') : '';

  // DOS move workflow will add a storm:move-state to lineage
  if (moveState) {
    if (moveState === _consts.ENTITY_STATUS.PROCESSING) {
      return true;
    }
    if (moveState !== _consts.ENTITY_STATUS.SUCCESS) {
      return false;
    }
  }
  var processState = entity ? getEntityField(entity, 'processState') : '';
  if (!processState || [_consts.ENTITY_STATUS.PROCESSING_COMPLETE, _consts.ENTITY_STATUS.PROCESSING_ABORTED, _consts.ENTITY_STATUS.PROCESSING_SUSPEND].includes(processState)) {
    return false;
  }

  // Which means: no process state, PROCESSING_ABORTING, EXTRACTION_PENDING, PROCESSING, PROCESSING_COPYING
  // are all belongs to processing status.
  return true;
};
var isProcessFailure = exports.isProcessFailure = function isProcessFailure(entity) {
  var processResult = entity ? getEntityField(entity, 'processResult') : '';
  return processResult === _consts.ENTITY_STATUS.PROCESSING_FAILED;
};
var isSuspend = exports.isSuspend = function isSuspend(entity) {
  var processState = entity ? getEntityField(entity, 'processState') : '';
  return _consts.ENTITY_STATUS.PROCESSING_SUSPEND === processState;
};

/**
 * This is to check if the extraction is without any failure.
 * If a file doesn't go through the extractor, it will return false.
 *
 * @param entity - the file entity object with version property
 */
var isExtractionSuccess = exports.isExtractionSuccess = function isExtractionSuccess(entity) {
  if (!entity || isFolder(entity)) {
    return false;
  }
  var version = entity.version || {};
  // For documents in Plans folder, if the process state is complete, the extraction state is null.
  // However, it should be in a success state.
  return version.entityType === _consts.ENTITY_TYPE.SEED_FILE ? version.processState === _consts.ENTITY_STATUS.PROCESSING_COMPLETE && version.extractionState === _consts.ENTITY_STATUS.SUCCESS : version.processState === _consts.ENTITY_STATUS.PROCESSING_COMPLETE && version.extractionState !== _consts.ENTITY_STATUS.FAILED;
};

//
// Viewable related checks
//
var isViewableOfficeFile = exports.isViewableOfficeFile = function isViewableOfficeFile(doc) {
  var ext = getFileExtension((doc === null || doc === void 0 ? void 0 : doc.fileName) || (doc === null || doc === void 0 ? void 0 : doc.file_name));
  return _consts.OFFICE_FILE_VIEWABLE_EXTS.includes(ext);
};
var isEditableOfficeFile = exports.isEditableOfficeFile = function isEditableOfficeFile(doc) {
  var ext = getFileExtension((doc === null || doc === void 0 ? void 0 : doc.fileName) || (doc === null || doc === void 0 ? void 0 : doc.file_name));
  return _consts.OFFICE_FILE_EDITABLE_EXTS.includes(ext);
};
var isImageSupportLeafletView = exports.isImageSupportLeafletView = function isImageSupportLeafletView(doc) {
  var ext = getFileExtension(doc === null || doc === void 0 ? void 0 : doc.fileName);
  // 'png', 'jpg', 'jpeg' are removed for performance consideration at image worker phase 1
  if (['bmp', 'tif', 'tiff'].includes(ext) && getEntityField(doc, 'extractionState') === _consts.ENTITY_STATUS.SUCCESS) {
    return true;
  }
  return false;
};
var isViewableInProcessing = exports.isViewableInProcessing = function isViewableInProcessing(entity) {
  if (!entity || !entity.version) return false;
  // Only project files are applicable to view during processing
  var _entity$version8 = entity.version,
    entityType = _entity$version8.entityType,
    processState = _entity$version8.processState;
  return entityType === _consts.ENTITY_TYPE.SEED_FILE && !!processState && isProcessing(entity) && isProcessingState(processState);
};
var isViewableImage = exports.isViewableImage = function isViewableImage(entity) {
  if (!entity) return false;
  if (entity.fileName) {
    var ext = getFileExtension(entity.fileName);
    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return true;
    }
  }
  return false;
};
var isViewableImageNotProcessed = exports.isViewableImageNotProcessed = function isViewableImageNotProcessed(entity) {
  return !!entity && isViewableImage(entity) && getEntityField(entity, 'extractionState') !== _consts.ENTITY_STATUS.SUCCESS;
};
var isViewableVideo = exports.isViewableVideo = function isViewableVideo(entity) {
  return getFileExtension(entity === null || entity === void 0 ? void 0 : entity.name) === 'mp4';
};
var isViewableRcpFile = exports.isViewableRcpFile = function isViewableRcpFile(entity) {
  return getFileExtension(entity === null || entity === void 0 ? void 0 : entity.fileName) === 'rcp';
};
var isViewable = exports.isViewable = function isViewable(entity) {
  if (!entity || isFolder(entity)) {
    return false;
  }
  var version = entity.version || {};
  if (version.entityType === _consts.ENTITY_TYPE.DOCUMENT || version.entityType === _consts.ENTITY_TYPE.REVIEW_DOCUMENT) {
    // If processing state is aborted, we should return false.
    return version.processState !== _consts.ENTITY_STATUS.PROCESSING_ABORTED;
  }
  if (version.entityType === _consts.ENTITY_TYPE.SEED_FILE) {
    // As image file also send to DOS for processing, need to check image file viewable with
    // different logic for compatibility issue
    if (version.processState) {
      if (isProcessingState(version.processState)) {
        return true;
      }
      if (version.processState !== _consts.ENTITY_STATUS.PROCESSING_COMPLETE) {
        return false;
      }
      if (isViewableOfficeFile(entity) || isViewableImage(entity) || isViewableVideo(entity) || isViewableRcpFile(entity) || version.extractionState === _consts.ENTITY_STATUS.SUCCESS || version.partialExtractionFailure === true) {
        return true;
      }
    } else if (isViewableImage(entity)) {
      return true;
    }
  }
  return false;
};

/**
 * Return remapped file type that can be used to render a proper file icon.
 *
 * @example
 *
 * Use `@adsk/nirvana-doctype-icon` component to render the icon.
 * Setup the mapped type in the `type` prop.
 * ```
 *   import DoctypeIcon from '@adsk/nirvana-doctype-icon';
 *   const type = getDocType(entity);
 *   <DoctypeIcon type={type} />
 * ```
 *
 * @param entity - the entity object
 * @returns the remapped file type
 */
var getDocType = exports.getDocType = function getDocType(entity) {
  var docType;
  if (!entity) {
    return 'file';
  }
  if (entity instanceof _models.FolderItem || isFolder(entity)) {
    return 'folder';
  }
  if (isSuspend(entity)) {
    return isPdf(entity) ? 'pdf-native' : 'process-suspend';
  }
  var name = 'fileName' in entity ? entity.fileName : 'name' in entity ? entity.name : '';
  var extensionKey = _consts.FILE_TYPE_MAPPING[getFileExtension(name)];
  if (extensionKey) {
    docType = extensionKey;
  } else if (isFdx(entity)) {
    docType = 'exchange';
  } else if (isAggregateModel(entity)) {
    docType = 'aggregate';
  } else if ('isDocument' in entity && entity.isDocument) {
    docType = 'sheet';
  } else {
    docType = 'file';
  }
  return docType;
};

//
// Upload related
//
var isValidMatFile = exports.isValidMatFile = function isValidMatFile(file) {
  return new Promise(function (resolve) {
    if (!file || typeof window === 'undefined' || typeof window.FileReader !== 'function') {
      resolve(false);
      return;
    }
    var fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file.slice(0, 8));
    fileReader.onloadend = function (e) {
      var reader = e.currentTarget;
      var result = reader.result;
      if (result instanceof ArrayBuffer) {
        resolve((0, _isEqual["default"])((0, _toConsumableArray2["default"])(new Uint8Array(result)), _consts.MAT_FILE_SIGNATURE));
      } else {
        resolve(false);
      }
    };
    fileReader.onerror = function () {
      resolve(false);
    };
    fileReader.onabort = function () {
      resolve(false);
    };
  });
};
var getIdsByStorageUrn = function getIdsByStorageUrn() {
  var ossUrn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var relativeUrn = ossUrn.substring(ossUrn.lastIndexOf(':') + 1, ossUrn.length);
  return relativeUrn.split('/');
};
var getObjectIdByStorageUrn = exports.getObjectIdByStorageUrn = function getObjectIdByStorageUrn(ossUrn) {
  var idGroup = ossUrn ? getIdsByStorageUrn(ossUrn) : [];
  return idGroup.length > 1 ? idGroup[1] : '';
};
var getBucketIdByStorageUrn = exports.getBucketIdByStorageUrn = function getBucketIdByStorageUrn(ossUrn) {
  var idGroup = ossUrn ? getIdsByStorageUrn(ossUrn) : [];
  return idGroup.length > 0 ? idGroup[0] : '';
};

/**
 * To open a dwg with the AutoCAD web, a openUrl parameter is needed.
 * The AutoCAD web will use it to get the file content.
 * https://platform.stoplight.autodesk.com/docs/docs-cp/f1274cda31bbe-get-file-content
 *
 * @param config - The SDK configuration
 * @returns The open URL for the file
 */
var getOpenUrl = exports.getOpenUrl = function getOpenUrl(config) {
  var regionPath = config.getEnv('REGION_PATH', '');
  return "".concat(config.getBaseURL('DOCS_API_V3')).concat(regionPath, "/files/content");
};
var parseExtMetaPropertyValue = exports.parseExtMetaPropertyValue = function parseExtMetaPropertyValue(data) {
  var _ref = data || {},
    dataType = _ref.dataType,
    value = _ref.value;
  switch (dataType) {
    case _consts.EXT_META_PROPERTY_TYPES.STRING:
      return data;
    case _consts.EXT_META_PROPERTY_TYPES.INTEGER:
      return {
        dataType: dataType,
        value: Number.parseInt(value) || value
      };
    case _consts.EXT_META_PROPERTY_TYPES.DECIMAL:
      return {
        dataType: dataType,
        value: Number.parseFloat(value) || value
      };
    case _consts.EXT_META_PROPERTY_TYPES.BOOLEAN:
      return {
        dataType: dataType,
        value: /true/i.test(value)
      };
    case _consts.EXT_META_PROPERTY_TYPES.DATETIME:
      return {
        dataType: dataType,
        value: (0, _dates.dateStringReformat)(value)
      };
    default:
      return data;
  }
};
var getExtMetaProperties = exports.getExtMetaProperties = function getExtMetaProperties() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (Object.keys(properties).length === 0) return undefined;
  var result = {};
  for (var _i = 0, _Object$entries = Object.entries(properties); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    try {
      var parsedPropertyValue = parseExtMetaPropertyValue(value);
      var _key$split = key.split(':'),
        _key$split2 = (0, _slicedToArray2["default"])(_key$split, 2),
        namespace = _key$split2[0],
        property = _key$split2[1];
      result[namespace] = (0, _extends3["default"])({}, result[namespace], (0, _defineProperty2["default"])({}, property, parsedPropertyValue));
    } catch (error) {
      continue;
    }
  }
  return result;
};